import { Eye, Pencil, Trash2 } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";
import { FacilityRowActionsProps } from "../types/facilityList.types";

export const FacilityRowActions = ({ onView, onEdit, onDelete }: FacilityRowActionsProps) => (
  <div className="tw-flex tw-items-center tw-justify-end tw-gap-1">
    <Button variant="ghost" size="icon" className="tw-h-8 tw-w-8" title="View" onClick={onView}>
      <Eye className="tw-h-3.5 tw-w-3.5" />
    </Button>
    <Button variant="ghost" size="icon" className="tw-h-8 tw-w-8" title="Edit" onClick={onEdit}>
      <Pencil className="tw-h-3.5 tw-w-3.5" />
    </Button>
    <Button
      variant="ghost"
      size="icon"
      className="tw-h-8 tw-w-8 tw-text-destructive hover:tw-text-destructive"
      title="Delete"
      onClick={onDelete}
    >
      <Trash2 className="tw-h-3.5 tw-w-3.5" />
    </Button>
  </div>
);
